import Image from "next/image";
import { twMerge } from "tailwind-merge";
import Text from "../Text/Text";

interface CardInterface {
    width?: string;
    height?: string;
    hasImage?: boolean;
    imageSize?: string;
    titleSize?: string;
    contentSize?: string;
    hasText?: boolean;
    hasButton?: boolean;
    buttonPlacement?: string;
    title?: string;
    content?: string;
    border?: string;
    backgroundColor?: string;
    imgSrc?: string;
    button?: JSX.Element | null;
    titlePlacement?: string;
    textSize?: string;
    textColor?: string;
    hasPretitle?: boolean;
    pretitle?: string;
    hasList?: boolean;
    listItems?: string[];
    leadings?: string;
    imgPlacement?: string;
    spacing?: string;
    leadingText?: string;
    pretitleSize?: string;
    hasSubTitle?: boolean;
    subTitle?: string;
    imageHeight?: number;
    imageWidth?: number;
}
export default function Card({
    width = "w-76 md:w-280 lg:w-280",
    height = "h-180 md:h-122 lg:h-122",
    hasImage = true,
    imageSize = "lg:h-73 lg:w-full md:h-73 md:w-full w-70 h-73",
    titleSize = "lg:text-2xl md:text-2xl text-xl lg:leading-relaxed md:leading-relaxed leading-7",
    contentSize = "lg:text-xl1 text-lg lg:leading-8.5 leading-7",
    hasText = true,
    hasButton = true,
    buttonPlacement = "justify-start",
    title = "",
    content = "",
    border = "border-2 border-black",
    backgroundColor = "bg-neutral-100 bg-opacity-70",
    imgSrc = "",
    button = null,
    titlePlacement = "items-start",
    textSize = "text-lg leading-7",
    textColor = "text-black",
    hasPretitle = false,
    pretitle = "",
    hasList = false,
    listItems = [],
    leadings = "",
    imgPlacement = "mx-auto",
    spacing = "gap-2",
    leadingText = "",
    pretitleSize,
    hasSubTitle = false,
    subTitle,
    imageHeight = 400,
    imageWidth = 400,
}: CardInterface) {
    return (
        <div
            className={twMerge(
                "pt-6 px-6  relative rounded-lg  flex-col justify-start items-start  inline-flex",
                width,
                height,
                border,
                backgroundColor,
            )}
        >
            {hasImage && (
                <div className={`${imgPlacement}`}>
                    <Image
                        className={twMerge(
                            "self-stretch rounded-lg objectCover",
                            imageSize,
                        )}
                        src={imgSrc}
                        style={{ objectFit: "cover" }}
                        alt=""
                        width={imageWidth}
                        height={imageHeight}
                    />
                </div>
            )}
            <div className={twMerge("self-stretch relative  flex-col flex", spacing)}>
                <Text
                    title={title}
                    paragraphs={[content]}
                    hasSubTitle={hasSubTitle}
                    hasText={hasText}
                    titleSize={titleSize}
                    textSize={textSize}
                    textColor={textColor}
                    paddings=""
                    titlePlacement={titlePlacement}
                    hasPretitle={hasPretitle}
                    pretitle={pretitle}
                    leading={leadings}
                    leadingText={leadingText}
                    pretitleSize={pretitleSize}
                    subTitle={subTitle}
                />
            </div>
            <div>
                {hasList ? (
                    <div className="lg:flex justify-between">
                        <div>
                            {listItems.map((li) => {
                                return (
                                    <div
                                        key={li}
                                        className="text-black text-lg font-normal  leading-8.5"
                                    >
                                        {li}
                                    </div>
                                );
                            })}
                        </div>
                        <div className={twMerge("flex", buttonPlacement)}>
                            {hasButton && button}
                        </div>
                    </div>
                ) : (
                    <> {hasButton && button}</>
                )}
            </div>
        </div>
    );
}
